/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespContainer_vipUserRelationship = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_vipUserRelationship",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_vipUserRelationship",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_vipUserRelationship",
      "args": null
    }
  ],
  "type": "UserRelationship"
};

module.exports = fragment;
